// export const APILINK = 'http://192.168.88.19:1111'
export const APILINK = 'https://revolt-back.div-systems.com'
